import React from "react";
import SideMenu from "./../../SideMenu";
import useIsMobile from "../../../Hooks/useIsMobile";
import { translate } from "../../../Services/translation";
import { useInstantSearch } from "react-instantsearch";
import CustomClearRefinements from "./CustomClearRefinements";
import { MobileRefinementsMenuProps } from "./types/MobileRefinementsMenuProps";

const MobileRefinementsMenu = ({
  isOpen,
  onClosed,
  children,
}: MobileRefinementsMenuProps) => {
  const { results } = useInstantSearch();
  const isMobile = useIsMobile("medium-large");
  const numberOfResults = !results.__isArtificial ? results.nbHits : 0;

  const footer = (
    <div className="algolia-refinements-menu-footer-buttons">
      <CustomClearRefinements />
      <button
        className="btn btn--primary btn--fullwidth btn--algolia"
        onClick={onClosed}
      >
        <span>{translate("global.show")}</span> ({numberOfResults})
      </button>
    </div>
  );

  return (
    isMobile && (
      <SideMenu
        className="algolia-mobile-refinements-menu"
        id="AlgoliaMobileRefinementsMenu"
        header={translate("mobile-filter-menu.title")}
        footer={footer}
        from="left"
        open={isOpen}
        onClosed={onClosed}
      >
        {children}
      </SideMenu>
    )
  );
};

export default MobileRefinementsMenu;
